import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, finalize } from 'rxjs';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CustomValidator } from 'src/app/services/validation';
import { AccountService } from '../account.service';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { UtilitySupport } from 'src/app/utils/UtilitySupport';
export function MustMatch(controlName: any, matchingControlName: any) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors['MustMatch']) {
      return;
    }
    // 
    var d = control.value;
    // 
    if (d !== matchingControl.value) {
      matchingControl.setErrors({ MustMatch: true });
    }

    else {
      matchingControl.setErrors(null);
    }
  }

}
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})


export class SignUpComponent implements OnInit, OnDestroy {
  signUpForm!: FormGroup;
  companySelected: boolean = true;
  license = '';
  category:any[] = [];
  location: any[] = [];
  isMobileVerified = false;
  isEmailVerified = false;
  isSubmitted = false;
  loadingSubject = new BehaviorSubject<boolean>(false);
  disableMobileOtp: boolean = false;
  disableEmailOtp: boolean = false;
  emailTimerText = '';
  mobileTimerText = '';
  isMobileTimerEnable = false;
  isEmailTimerEnable = false;
  isSSOVerified = false;
  showMobileOtp: boolean = false
  showEmailOtp: boolean = false
  strengthMsg: any;
  msgColor: any;
  @ViewChild('canvas')
  canvas!: ElementRef<HTMLCanvasElement>;
  answer: string = '';
  enableMobile: boolean = true;
  // Observables to subscribe, to get the subject's values
  public loading$ = this.loadingSubject.asObservable();
  selectedBusiness: any;
  constructor(public dialog: MatDialog, private fb: FormBuilder, private accountService: AccountService,

    private router: Router, public snackbarService: SnackbarService) {
    this.selectedBusiness = sessionStorage.getItem('Business');
    if (this.selectedBusiness) {

    } else {
      this.router.navigate(['/auth/login-selection']);
    }
  }

  ngOnInit(): void {
    this.getLocation();
    this.buildSignUpForm();
    this.signUpForm.controls['mobile'].valueChanges.subscribe(data => {
      this.isMobileVerified = false;
      this.signUpForm.controls['mobileOtp'].patchValue('')
    })

    setTimeout(() => {
      this.createCaptcha();
    }, 300);
    // this.signUpForm.get('owenership').valueChanges
    // .subscribe(value => {
    //   if(value == 'Company') {
    //     this.companySelected = true
    //     console.log(value)
    //     this.signUpForm.addControl('company_name',new FormControl('',[Validators.required]));
    //     console.log(this.signUpForm)
    //     // this.signUpForm.get('myEmailField').setValidators(this.emailValidators.concat(Validators.required))
    //   } else {
    //     this.companySelected = false
    //     this.signUpForm.removeControl('company_name');
    //     console.log(this.signUpForm)
    //     // this.signUpForm.get('myEmailField').setValidators(this.emailValidators);
    //   }
    // });

    let cookiesData: Array<string> = document.cookie.split(';');
    if (cookiesData.length > 0) {
      let email = cookiesData.find(data => {
        return data.includes('jwt-email');
      });
      if (email) {
        let splitItems = email.split('=');
        splitItems[1] = decodeURIComponent(splitItems[1]);
        this.signUpForm.controls['email'].patchValue(splitItems[1]);
        this.isEmailVerified = true;
        this.isEmailTimerEnable = false;
        this.isSSOVerified = true;
        this.openSnackbar('To Proceed Please Provide Required Information.')
      }
    }
  }

  buildSignUpForm() {
    this.signUpForm = this.fb.group({
      // owenership:['Company', Validators.required],
      // company_name: ['',Validators.required],
      subcontractor_name: ['', [Validators.required, CustomValidator.NameValidationWithoutNumeric]],
      country_id: ['', [Validators.required]],
      phone_code: [{ value: '', disabled: true }, [Validators.required]],
      mobile: ['', [Validators.required, CustomValidator.lessThanTenDigitMobileNumber]],
      mobileOtp: [''],
      email: ['', [Validators.required, CustomValidator.email]],
      emailOtp: [''],
      contractor_type_id: ['', [Validators.required]],
      password: ['', [Validators.required, CustomValidator.password]],
      confirm_password: ['', [Validators.required]],
      is_terms_accepted: [false, [Validators.requiredTrue]],
      captcha: ['',],
      captcha1: [''],
    }, {
      validator: [CustomValidator.passwordMatchValidator, MustMatch('captcha1', 'captcha')],
    },)
  }



  //Add:
  // this.formTest.addControl('phoneNumber',['', Validators.required]);

  //Remove:
  // this.formTest.removeControl('phoneNumber');

  doRegister() {

    // Do not load if already loading
    if (this.loadingSubject.value) {
      return;
    }

    // We are currently loading values
    this.signUpForm.markAsTouched();
    this.isSubmitted = true;
    if (this.signUpForm.invalid) {
      this.openSnackbar('Please validate the form');
      return
    }
    if (!this.isMobileVerified) {
      this.openSnackbar('Mobile should be verified');
      return
    }
    if (!this.isEmailVerified) {
      this.openSnackbar('Email should be verified');
      return
    }


    this.loadingSubject.next(true);

    let request = {
      ...this.signUpForm.value
    }
    delete request.mobileOtp;
    delete request.emailOtp;
    delete request.captcha;
    delete request.captcha1;
    request['business'] = sessionStorage.getItem('Business');
    this.accountService.registerUser(request).pipe(finalize(() => this.loadingSubject.next(false))).subscribe((data: any) => {
      if (data['message'] == 'Sign up Successfully') {
        // sessionStorage.setItem('token',data['token']);
        // sessionStorage.setItem('userdata',JSON.stringify(data['data']));
        this.openSnackbar(data['message']);
        this.router.navigate(['/auth/login']);
      } else {
        this.openSnackbar(data['message']);
      }
    }
      , error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
      })

  }

  getLocation() {
    let business = sessionStorage.getItem('Business')
    this.accountService.getLocation({ business: business }).subscribe(data => {
      this.license = data.data.license;
      this.location = data.data.location;
    }, error => {
      let message = error.error || error.error[0];
      this.openSnackbar(message.error);
    })
  }

  openDialog() {
    const dialogRef = this.dialog.open(TermsAndConditionsComponent, {
      width: '900px'
    });
  }

  setPhonecode(val: any) {
    this.enableMobile = true;
    this.isMobileVerified = false;
    this.isMobileTimerEnable = false;
    this.signUpForm.controls['mobile'].patchValue('');
    if (val) {
      const selectedObj = this.location.find((data: any) => data.country_id == val);

      if (selectedObj) {
        this.signUpForm?.controls['phone_code']?.patchValue(selectedObj.phone_code);
      }
      // let selectedObj = this.location.find((data:any) => data.country_id == val);
      // this.signUpForm?.controls['phone_code']?.patchValue(selectedObj.phone_code);
    } 
    
    else {
      this.signUpForm.controls['phone_code'].patchValue('');
    }
  }

  getMobileOtp() {
    if (this.signUpForm.controls['phone_code'].value && this.signUpForm.controls['mobile'].valid) {
      let request = {
        mobile: this.signUpForm.controls['mobile'].value,
        phone_code: this.signUpForm.controls['phone_code'].value
      }
      this.disableMobileOtp = true;
      this.accountService.generateOTP(request).subscribe((data: any) => {
        this.openSnackbar(data['message']);
        if (data['status'] == 400) {
          this.disableMobileOtp = false;
          return
        }
        if (data['status'] == 200) {
          this.enableMobile = false;
          this.isMobileTimerEnable = true;
          this.startCountdownForMobile();
          setTimeout(() => {
            this.disableMobileOtp = false;
          }, 20000);
        } else {
          this.disableMobileOtp = false;
          this.openSnackbar(data['message']);
        }


      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
        this.disableMobileOtp = false;
      })
    } else if (!this.signUpForm.controls['phone_code'].value && this.signUpForm.controls['mobile'].valid) {
      this.openSnackbar('Please select a location')
    } else if (this.signUpForm.controls['phone_code'].value && !this.signUpForm.controls['mobile'].valid) {
      this.openSnackbar('Mobile number should be vaild')
    } else {
      this.openSnackbar('Country code and Mobile number should be vaild')
    }
  }

  VerifiedMobileOTP() {


    if (this.signUpForm.controls['phone_code'].value && this.signUpForm.controls['mobile'].valid && this.signUpForm.controls['mobileOtp'].valid) {

      let saltReq = {
        username: this.signUpForm.controls['mobile'].value,
      }
      this.accountService.getCommonOtpSalt(saltReq).subscribe((saltData: any) => {
        if (saltData['status'] == 200) {
          let request = {
            mobile: this.signUpForm.controls['mobile'].value,
            otp: UtilitySupport.encodeSalt(this.signUpForm.controls['mobileOtp'].value, saltData['salt'])
          }
          this.accountService.verifyOTP(request).subscribe((data: any) => {
            if (data['status'] == 200 && data['message'] == 'OTP verified successfully') {
              this.isMobileVerified = true;
              this.isMobileTimerEnable = false;
              this.enableMobile = false;
              this.openSnackbar(data['message']);
            } else {
              this.openSnackbar(data['message']);
            }
            // this.openSnackbar(data['message'])
          }, error => {
            let message = error.error || error.error[0];
            this.openSnackbar(message.error);
          })

        }
      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
      })

    } else {
      this.openSnackbar('Country code, Mobile number and OTP should be vaild')
    }
  }

  getEmailOtp() {
    if (this.signUpForm.controls['email'].valid) {
      console.log('valid')
      let request = {
        email: this.signUpForm.controls['email'].value
      }
      this.disableEmailOtp = true;

      this.accountService.generateOTP(request).subscribe((data: any) => {
        this.openSnackbar(data['message']);
        if (data['status'] == 200) {
          setTimeout(() => {
            this.disableEmailOtp = false;
            this.startCountdownForEmail();
            this.isEmailTimerEnable = true;
          }, 200);
        } else {

          this.disableEmailOtp = false;
          this.openSnackbar(data['message']);
        }


      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
        this.disableEmailOtp = false;
      })
    } else {
      this.openSnackbar('Email should be vaild')
    }
  }

  VerifiedEmailOTP() {
    if (this.signUpForm.controls['email'].valid && this.signUpForm.controls['emailOtp'].valid && this.signUpForm.controls['mobileOtp'].valid) {
      // let request = {
      //   email: this.signUpForm.controls['email'].value,
      //   otp: UtilitySupport.encode( this.signUpForm.controls['emailOtp'].value)
      // }
      let saltReq = {
        username: this.signUpForm.controls['email'].value,
      }
      this.accountService.getOtpSalt(saltReq).subscribe((saltData: any) => {
        if (saltData['status'] == 200) {
          console.log('saltData = ', saltData)
          let request = {
            email: this.signUpForm.controls['email'].value,
            otp: UtilitySupport.encodeSalt(this.signUpForm.controls['emailOtp'].value, saltData['salt'])
          }
          this.accountService.verifyOTP(request).subscribe((data: any) => {
            if (data['message'] == 'OTP verified successfully') {
              this.isEmailVerified = true;
              this.isEmailTimerEnable = false;
              this.openSnackbar(data['message']);
            } else {
              this.openSnackbar(data['message']);
            }
            // this.openSnackbar(data['message'])
          }, error => {
            let message = error.error || error.error[0];
            this.openSnackbar(message.error);
          })

        }
      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
      })

    } else {
      this.openSnackbar('Email and OTP should be vaild')
    }
  }

  navigateLogin() {
    this.router.navigate(['/auth/login'])
  }

  /**
* open toaster for showing message 
*/
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

  startCountdownForEmail() {
    var counter = 60 * 2;

    var interval = setInterval(() => {
      sessionStorage.setItem('timer', counter + '')
      let minutes = Math.floor((counter % 3600) / 60);
      let seconds = Math.floor(counter % 60);
      let minute = minutes < 10 ? "0" + minutes : minutes;
      let second = seconds < 10 ? "0" + seconds : seconds;
      this.emailTimerText = minute + ":" + second;
      counter--;
      if (counter < 0) {

        // The code here will run when
        // the timer has reached zero.
        clearInterval(interval);
        this.emailTimerText = "00:00";
        this.isEmailTimerEnable = false;
      };
    }, 1000);
  }

  startCountdownForMobile() {
    var counter = 60 * 2;

    var interval = setInterval(() => {
      sessionStorage.setItem('timer', counter + '')
      let minutes = Math.floor((counter % 3600) / 60);
      let seconds = Math.floor(counter % 60);
      let minute = minutes < 10 ? "0" + minutes : minutes;
      let second = seconds < 10 ? "0" + seconds : seconds;
      this.mobileTimerText = minute + ":" + second;
      counter--;
      if (counter < 0) {

        // The code here will run when
        // the timer has reached zero.
        clearInterval(interval);
        this.mobileTimerText = "00:00";
        this.isMobileTimerEnable = false;
        this.enableMobile = true;
      };
    }, 1000);
  }

  validateNo(e:any): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  passwordstrength() {
    let pwd = this.signUpForm.value.password

    if (pwd.length === 6) {
      this.strengthMsg = "Poor Password";
      this.msgColor = "Red";
    } else if (pwd.length >= 7 && pwd.length <= 9) {
      this.strengthMsg = "Weak Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 10 && pwd.length <= 12) {
      this.strengthMsg = "Average Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 13 && pwd.length <= 20) {
      this.strengthMsg = "Strong Password";
      this.msgColor = "green";
    }

  }

  ngOnDestroy() {
    document.cookie = 'jwt-email' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  getCategories(countryId:any) {
    let req = {
      business: sessionStorage.getItem('Business'),
      country_id: countryId
    }
    this.accountService.getCategories(req).subscribe(data => {
      this.category = data.data;
      console.log(this.category)
    }, error => {
      let message = error.error || error.error[0];
      this.openSnackbar(message.error);
    })
  }

  createCaptcha() {
    const ctx: any = this.canvas.nativeElement.getContext("2d");
    let captchaStr = this.randomString(6, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    this.answer = captchaStr
    this.signUpForm.controls['captcha1'].setValue(this.answer);
    ctx.font = "30px Poppins";
    ctx.fillText(captchaStr, 10, 35);

  }

  refreshCaptcha() {
    const ctx: any = this.canvas.nativeElement.getContext("2d");
    ctx.clearRect(0, 0, 150, 200)
    this.createCaptcha();

    this.signUpForm.controls['captcha'].reset();
    this.answer = this.answer + 25;
    // ctx.fillStyle = "#ffffff";
  }

  random() {
    return Math.floor(Math.random() * 10) + 1;
  }

  randomString(length:any, chars:any) {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
    return result;
  }

  enableMobileEdit() {
    this.enableMobile = true
    this.isMobileVerified = false;
  }
}
